export enum VolleyballCardsAttribute {
  YellowCard = 521,
  RedCard = 522,
  PlayerExpulsion = 523,
  PlayerDisqualification = 524,
}
